import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import MnComboStandalone from "@mnjsplatform/components/lib/common/Dropdown/MnComboStandalone";
import ScheduleVacationList from "./ScheduleVacationList";
import RequestScheduleVacationList from "./RequestScheduleVacationList";

class ScheduleVacation extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            currentYear: null, methodInfo: null, isViewEditSched: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.SchedHolidayYear_SelectOnePO.reset());
            await this.props.dispatch(this.props.SchedHolidayYear_SelectOnePO.initialize());
            await this.changeYear(0);
        } catch (e) {
            console.error(e);
        }
    }

    refresh = async () => {
        let key = {"NumYear": this.state.currentYear};
        await this.props.dispatch(this.props.ShedHolidayDetail_GetViewDetail.execute(key));
        const methodInfo = this.props.ShedHolidayDetail_GetViewDetail.getRow(0);
        this.setState({methodInfo: methodInfo});
    }

    changeYear = async (selectedIndex) => {
        if (selectedIndex < 0) return;
        const row = this.props.SchedHolidayYear_SelectOnePO.getRow(selectedIndex);
        this.setState({currentYear: row.NumYear, isViewEditSched: row.IsViewEditSched === 1}, this.refresh);
    }

    render() {
        return (<>
            {/*<PlaceholderWrapper placeholderId="10"
                                    showSplitterLine={true}
                                    collapsed={true}
                                    title={<><i className='fa fa-info'/> {i18next.t("Инструкция для работников")}</>}
                                    canCollapse={true}>
                    {ScheduleVacationInstruction()}
                </PlaceholderWrapper>*/}
            <PlaceholderWrapper placeholderId="ScheduleVacation_10" title={i18next.t("Schedule_Vacation")}
                                showSplitterLine={false}
                                canCollapse={false}>
                <div className="d-inline-flex p-2">{i18next.t("VacationsFor")}&nbsp;
                    <MnComboStandalone
                        ownItem={this.props.SchedHolidayYear_SelectOnePO}
                        style={{cursor: 'pointer'}}
                        valueFieldName="NumYear"
                        withSearch={false} onSelected={this.changeYear}/>
                </div>
                <ScheduleVacationList currentYear={this.state.currentYear} methodInfo={this.state.methodInfo}
                                      isViewEditSched={this.state.isViewEditSched}/>
            </PlaceholderWrapper>
            <PlaceholderWrapper placeholderId="ScheduleVacation_20"
                                title={i18next.t("Requests_Schedule_Vacation")}
                                showSplitterLine={false}
                                canCollapse={false}>
                <RequestScheduleVacationList currentYear={this.state.currentYear}/>
            </PlaceholderWrapper>
        </>);
    }
}

ScheduleVacation.propTypes = {
    dispatch: PropTypes.func.isRequired,
    SchedHolidayYear_SelectOnePO: PropTypes.object,
    ShedHolidayDetail_GetViewDetail: PropTypes.object
};

ScheduleVacation.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        SchedHolidayYear_SelectOnePO: state.vacationState.SchedHolidayYear_SelectOnePO,
        ShedHolidayDetail_GetViewDetail: state.vacationState.ShedHolidayDetail_GetViewDetail
    }
}

export default connect(mapStateToProps)(ScheduleVacation);